import { useEffect, useState } from 'react';
import { Nav, Navbar, NavDropdown } from 'react-bootstrap';
import { AuthenticatedTemplate, UnauthenticatedTemplate, useMsal } from '@azure/msal-react';
import { loginRequest } from '../authConfig';
import { useNavigate } from 'react-router-dom';
import useStore from '../useStore';
import axios from 'axios';

const NavigationBar = () => {
    const { instance } = useMsal();
    const activeAccount = instance.getActiveAccount();
    const userEmail = useStore((state) => state.userEmail);
    const setUserEmail = useStore((state) => state.setUserEmail);
    const navigate = useNavigate();
    const [profileData, setProfileData] = useState(null);
    const resetUserEmail = useStore((state) => state.resetUserEmail);
    const [isSystemUser, setIsSystemUser] = useState(false);
    const [checkedUser, setCheckedUser] = useState(false);

    useEffect(() => {
        if (activeAccount && !profileData) {
      setProfileData(activeAccount.idTokenClaims);
      const emails = activeAccount.idTokenClaims.emails;
      if (emails && emails.length > 0) {
        const email = emails[0];
        console.log('Email captured in ProfileDetails:', email);
        if (!userEmail) {
          setUserEmail(email);
        }
      } else {
        console.error('No email found in idTokenClaims');
      }
      
      if (userEmail) {
            axios
                .get(`${process.env.REACT_APP_API_URL}/SystemUser?email=${userEmail}`)
                .then((response) => {
                    const user = response.data;
                    // If systemUserId is NOT all zeros → valid CRM user
                    const validUser =
                        user.systemUserId &&
                        user.systemUserId !== '00000000-0000-0000-0000-000000000000';
                    setIsSystemUser(validUser);
                    setCheckedUser(true);
                })
                .catch((error) => {
                    console.error('Error checking SystemUser:', error);
                    setCheckedUser(true);
                });
        }
        }
    }, [activeAccount, profileData, setUserEmail, userEmail]);

    const handleLoginRedirect = () => {
        instance.loginRedirect(loginRequest).catch((error) => console.log(error));
    };

    const handleLogoutRedirect = () => {
        resetUserEmail();
        instance.logoutRedirect().catch((error) => console.log(error));
    };

    return (
        <Navbar bg="primary" variant="dark" expand="lg" className="navbarStyle">
            <Navbar.Brand href="/">
                <img
                    src="UnitedWayLogo.png"
                    width="30"
                    height="30"
                    className="d-inline-block align-top"
                    alt="United Way Logo"
                />{' '}
                United Way of Greater Los Angeles AgencyHub
            </Navbar.Brand>
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse id="basic-navbar-nav">
                <Nav className="ms-auto">
                    <Nav.Link onClick={() => navigate('/about')}>About</Nav.Link>
                    <Nav.Link onClick={() => navigate('/agency-search')}>
                        Agency Search
                    </Nav.Link>

                    <AuthenticatedTemplate>
                        <Nav.Link onClick={() => navigate('/payments')}>Payments</Nav.Link>
                        <Nav.Link onClick={() => navigate('/donor-info')}>
                            Donor List
                        </Nav.Link>

                        {/* ✅ Admin Portal only for system users */}
                        {checkedUser && isSystemUser && (
                            <Nav.Link onClick={() => navigate('/admin-portal')}>
                                Admin Portal
                            </Nav.Link>
                        )}

                        <NavDropdown title="Profile" id="basic-nav-dropdown" align="end">
                            <NavDropdown.Item onClick={() => navigate('/profile-details')}>
                                Profile Info
                            </NavDropdown.Item>
                            <NavDropdown.Item onClick={() => navigate('/agency-info')}>
                                Agency Information
                            </NavDropdown.Item>
                            <NavDropdown.Item onClick={handleLogoutRedirect}>
                                Sign Out
                            </NavDropdown.Item>
                        </NavDropdown>
                    </AuthenticatedTemplate>

                    <UnauthenticatedTemplate>
                        <Nav.Link onClick={handleLoginRedirect}>Sign In</Nav.Link>
                    </UnauthenticatedTemplate>
                </Nav>
            </Navbar.Collapse>
        </Navbar>
    );
};

export default NavigationBar;
